import { useClassroomQuery } from '@innovamat/glow-api-client';
import { useUser } from '../../user-management';
import type { Classroom } from '../modules/classroom';

type Props = {
  classroomId?: string;
  enabled?: boolean;
};

type UseClassroom = {
  classroom: Classroom | undefined;
  isFetching: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
};

function useClassroom({ classroomId, enabled = true }: Props): UseClassroom {
  const { isRole } = useUser();
  const { data, isFetching, isLoading, isError, error } = useClassroomQuery(
    {
      id: classroomId || '',
    },
    {
      enabled: !!classroomId && enabled && !isRole.Student,
      retry: false,
      staleTime: Infinity,
    }
  );

  return {
    classroom: (data?.classroom as Classroom) || undefined,
    isFetching,
    isLoading,
    isError,
    error: (error as Error) || null,
  };
}

export { useClassroom };
